import {
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTION_SUCCESS,
  TOGGLE_SUBSCRIPTION_MODAL,
  UPDATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_ERROR,
  UPDATE_SUBSCRIPTION_SUCCESS,
} from "./actionTypes";

const initialState = {
  // subscriptions
  loadingSubscriptions: false,
  loadingSubscriptionsSuccess: false,
  loadingSubscriptionsError: null,
  subscriptions: {},
  // get subscription
  getSubscriptionLoading: false,
  getSubscriptionError: null,
  getSubscriptionSuccess: null,
  // update subscription
  updateSubscriptionLoading: false,
  updateSubscriptionError: null,
  updateSubscriptionSuccess: null,
};

const subscriptions = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTIONS:
      state = {
        ...state,
        updateSubscriptionSuccess: false,
        loadingSubscriptions: true,
        loadingSubscriptionsSuccess: false,
        loadingSubscriptionsError: null,
        subscriptions: [],
        subscription: {},
      };
      break;
    case GET_SUBSCRIPTIONS_SUCCESS:
      state = {
        ...state,
        loadingSubscriptions: false,
        loadingSubscriptionsSuccess: true,
        loadingSubscriptionsError: null,
        subscriptions: action.payload,
      };
      break;
    case GET_SUBSCRIPTIONS_ERROR:
      state = {
        ...state,
        loadingSubscriptionsError: action.payload,
        loadingSubscriptions: false,
        loadingSubscriptionsSuccess: false,
        subscriptions: [],
      };
      break;
    case GET_SUBSCRIPTION:
      state = {
        ...state,
        subscription: {},
        getSubscriptionLoading: true,
        getSubscriptionSuccess: false,
        getSubscriptionError: null,
      };
      break;
    case GET_SUBSCRIPTION_SUCCESS:
      state = {
        ...state,
        getSubscriptionError: null,
        getSubscriptionSuccess: true,
        getSubscriptionLoading: false,
        subscription: action.payload,
      };
      break;
    case GET_SUBSCRIPTION_ERROR:
      state = {
        ...state,
        getSubscriptionError: action.payload,
        getSubscriptionLoading: false,
        getSubscriptionSuccess: false,
      };
      break;
    case UPDATE_SUBSCRIPTION:
      state = {
        ...state,
        updateSubscriptionLoading: true,
        updateSubscriptionError: null,
        updateSubscriptionSuccess: false,
      };
      break;
    case UPDATE_SUBSCRIPTION_SUCCESS:
      state = {
        ...state,
        updateSubscriptionLoading: false,
        updateSubscriptionError: null,
        updateSubscriptionSuccess: true,
      };
      break;
    case UPDATE_SUBSCRIPTION_ERROR:
      state = {
        ...state,
        updateSubscriptionLoading: false,
        updateSubscriptionError: action.payload,
        updateSubscriptionSuccess: true,
        subscription: {},
      };
      break;
    case TOGGLE_SUBSCRIPTION_MODAL:
      state = {
        ...state,
        subscription: {},
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default subscriptions;
